import React from "react";
import { Twitter, Instagram, ArrowUp } from "lucide-react";

export default function Footer() {
  const scrollTop = () =>
    window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#0D0D0D] text-[#FDFBF7] py-16 px-4 sm:px-6 overflow-hidden"
    >
      <div className="absolute inset-0 opacity-10 halftone-bg" style={{ filter: "invert(1)" }} />

      <div className="relative mx-auto max-w-7xl">
        <div className="grid lg:grid-cols-12 gap-8">
          <div className="lg:col-span-6">
            <div className="font-display font-black uppercase text-6xl sm:text-7xl tracking-tighter leading-[0.9]">
              IncInk
              <span className="text-[#FF0055]">.</span>
              <br />
              Creative
              <span className="text-[#FFD800]">★</span>
            </div>
            <p className="mt-6 font-body text-[#FDFBF7]/70 max-w-md text-2xl font-display font-black uppercase tracking-tight text-[#FFD800]">
              Your Digital Buddy!
            </p>
            <div className="mt-6 flex flex-col sm:flex-row gap-3">
              <a
                href="mailto:incinkcreative@gmail.com"
                data-testid="footer-email"
                className="inline-flex items-center gap-2 font-mono text-sm text-[#FFD800] hover:underline break-all"
              >
                incinkcreative@gmail.com
              </a>
              <a
                href="https://wa.me/919766990448"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp"
                className="inline-flex items-center gap-2 font-mono text-sm text-[#00E5FF] hover:underline"
              >
                Chat on WhatsApp
              </a>
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="font-mono text-xs uppercase tracking-widest text-[#FFD800] mb-4">
              Sitemap
            </div>
            <ul className="space-y-2 font-display font-bold uppercase">
              {["Services", "Work", "Process", "About", "Contact"].map((l) => (
                <li key={l}>
                  <a
                    href={`#${l.toLowerCase()}`}
                    className="hover:text-[#FFD800] transition-colors"
                    data-testid={`footer-link-${l.toLowerCase()}`}
                  >
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <div className="font-mono text-xs uppercase tracking-widest text-[#FFD800] mb-4">
              Elsewhere
            </div>
            <div className="flex gap-3">
              {[
                { Icon: Twitter, href: "https://x.com/IncInkCreative", label: "x" },
                { Icon: Instagram, href: "https://www.instagram.com/weareincink/", label: "instagram" },
              ].map(({ Icon, href, label }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`footer-social-${label}`}
                  aria-label={label}
                  className="w-11 h-11 brut-border bg-[#FDFBF7] text-[#0D0D0D] flex items-center justify-center hover:bg-[#FFD800] transition-colors"
                >
                  <Icon size={18} />
                </a>
              ))}
            </div>
            <button
              onClick={scrollTop}
              data-testid="footer-back-to-top"
              className="mt-8 inline-flex items-center gap-2 font-display font-bold uppercase text-sm tracking-wider hover:text-[#FFD800] transition-colors"
            >
              <ArrowUp size={16} /> Back to top
            </button>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-[#FDFBF7]/20 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 font-mono text-xs uppercase tracking-widest text-[#FDFBF7]/60">
          <div>© {new Date().getFullYear()} IncInk Creative.</div>
          <div>Built with caffeine, curiosity & two monitors.</div>
        </div>
      </div>
    </footer>
  );
}
